"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var FieldCheckbox_1 = __importDefault(require("components/Form/FieldCheckbox"));
var InputSimple_1 = __importDefault(require("components/Form/InputSimple"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var backend_1 = require("utils/backend");
var ResyncModal = function (_a) {
    var close = _a.close, company = _a.company;
    var _b = __read((0, backend_1.useCall)('transactions-resyncCompanyCall', { companyId: company.id }), 1), resync = _b[0];
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resync({ timeFrame: (0, mapValues_1.default)(values, function (v, k) { return k !== 'allowContinue' ? parseInt(v, 10) : v; }) })()];
                case 1:
                    _a.sent();
                    close();
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = { allowContinue: true };
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: true, onClose: close, label: "simple-modal-title", "aria-describedby": "simple-modal-description", maxWidth: "xs" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, subscription: { submitting: true }, initialValues: initialValues }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, __assign({ id: "customized-dialog-title" }, { children: (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Resync ", (0, jsx_runtime_1.jsx)("strong", { children: company.name })] })) })), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [(0, jsx_runtime_1.jsx)(FieldCheckbox_1.default, { label: "Since last successful sync", name: "allowContinue", disabled: submitting }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, inputType: "number", label: "Years", name: "years", disabled: submitting }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, inputType: "number", label: "Months", name: "months", disabled: submitting }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, inputType: "number", label: "Days", name: "days", disabled: submitting })] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: submitting, type: "submit", size: "large" }, { children: "Submit" })) })] })));
            } })) })));
};
exports.default = ResyncModal;
